import { colors } from "../../../../common/styles";

const { black, lightGrey } = colors;

const ACCORDION_HEADER_MIN_HEIGHT = 50;
const ACCORDION_HEADER_MAX_HEIGHT = 60;
const ACCORDION_DETAILS_MAX_HEIGHT = 225;

const COMMON_HW = 84;
export default {
    accordionContainer: {
        borderBottom: "1px solid #ddd"
    },
    accordionHeader: {
        minHeight: `${ACCORDION_HEADER_MIN_HEIGHT}px !important`,
        maxHeight: ACCORDION_HEADER_MAX_HEIGHT
    },
    accordionDetails: {
        padding: 0,
        display: "block",
        maxHeight: ACCORDION_DETAILS_MAX_HEIGHT,
        overflow: "scroll"
    },
    auditorContainerWapper: {
        position: "relative",
        width: "100%",
        height: "100%"
    },
    auditorContainer: {
        position: "absolute",
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        bottom: 0,
        height: COMMON_HW,
        margin: "auto"
    },
    exclusionContainer: {
        mx: 0.5,
        "& svg": {
            marginRight: 0.5
        }
    },
    buttonContainer: {
        display: "inline-block"
    },
    buttonStyle: {
        width: "40%",
        borderRadius: "25px",
        m: 2
    },
    buttonBorderRadius: {
        borderRadius: "25px"
    },
    flexGrow: {
        flexGrow: 1
    },
    fullHeight: {
        height: "100%"
    },
    iconLeft: {
        marginLeft: -2
    },
    // Distinct from noImagesPlaceHolder on purpose. That dark slab states a
    // finding — the auditor submitted this asset and captured nothing. This one
    // warns that data is still in flight, so it carries the same amber as the
    // pending-count banner on the summary page rather than the dark treatment.
    imagesPendingPlaceHolder: {
        background: "#FFF3CD",
        border: "1px solid #FFEEBA",
        borderRadius: 1,
        color: "#856404",
        padding: "1em",
        textAlign: "center",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 0.5
    },
    // A non-mandatory asset is outside the scope of the count, so this states a
    // fact rather than a finding. It carries the same amber as
    // nonMandatoryAssetPageBanner below, not noImagesPlaceHolder's dark slab —
    // that one is reserved for the auditor having submitted no images at all,
    // which is something the controller has to act on.
    nonMandatoryAssetPlaceHolder: {
        background: "#FFF3CD",
        border: "1px solid #FFEEBA",
        borderRadius: 1,
        color: "#856404",
        padding: "1em",
        textAlign: "center"
    },
    noImagesPlaceHolder: {
        "&:hover": {
            opacity: 0.7
        },
        background: "rgba(0, 0, 0, 0.75)",
        color: "white",
        padding: "1em",
        textAlign: "center",
        transition: "all 1s"
    },
    spacer: {
        height: 3
    },
    historyTextStyle: {
        marginRight: 0.5,
        fontSize: 12,
        textTransform: "capitalize"
    },
    imageModal: {
        margin: "auto",
        maxWidth: "50%",
        maxHeight: "50%"
    },
    imageThumbContainer: {
        display: "flex",
        my: 2,
        "& div": {
            width: 125,
            height: 125
        }
    },
    assetFound: {
        px: 2,
        py: 1
    },
    columnLabel: {
        color: lightGrey,
        marginRight: 5,
        width: 85,
        textOverflow: "ellipsis",
        overflow: "hidden",
        whiteSpace: "nowrap",
        verticalAlign: "middle"
    },
    columnText: {
        color: black,
        width: "auto",
        fontSize: 0.8,
        textOverflow: "ellipsis",
        overflow: "hidden",
        verticalAlign: "middle",
        whiteSpace: "nowrap",
        width: 140
    },
    imageComponent: {
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        transition: "all 0.4s linear 0s",
        backgroundPosition: "center",
        width: "100%",
        height: "100%"
    },
    loadingContainer: {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        height: "10vh",
        width: "10vh"
    },
    centeredBannerWrapper: {
        height: "100%",
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    },
    nonMandatoryAssetPageBanner: {
        mx: 2,              
        mt: 1,
        mb: 1,
        background: "#FFF3CD",
        color: "#856404",
        border: "1px solid #FFEEBA",
        borderRadius: 1,
        px: 2,
        py: 1,
        fontWeight: 600
    }

};
